import React from 'react'
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

const blue = '#255A8D';

const styles = {
  root: {
    color: blue
  }
};

class BlueTypography extends React.Component {
  render() {
    const { classes, children, className, ...other } = this.props;
    return (
      <Typography classes={{
        root: classNames(classes.root, className),
      }} {...other}>
        {children || 'class names'}
      </Typography>
    );
  }

}

export default withStyles(styles)(BlueTypography);



// WEBPACK FOOTER //
// ./src/js/components/typography/BlueTypography.js